<script setup>
import { computed } from 'vue'
const props = defineProps({
    href: String,
    active: Boolean,
})

const classes = computed(() => {
    return props.active ? 'bg-white dark:bg-zinc-900 dark:text-white' : 'dark:text-gray-300 dark:hover:bg-zinc-900 dark:hover:text-white'
})
</script>

<template>
    <Link
        :href="href"
        :class="classes"
        class="rounded-md px-3 py-2 text-sm font-medium"
    >
        <slot />
    </Link>
</template>
